var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('vue-apex-charts',{attrs:{"type":"bar","height":"500","options":_vm.chartOptions,"series":_vm.seriesData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }